module.exports = __webpack_public_path__ + "static/media/logo.1dd91ed9.png";